import iconsMapData from '../../assets/tyris/icons-map.json';

export interface IconData {
  viewBox: string;
  inner: string;
}

export type TyrisIconName = keyof typeof iconsMapData | string;

const iconsMap: Record<string, IconData> = iconsMapData as Record<string, IconData>;

// Alias mapeando nombres en inglés o conceptos hacia iconos de Tyris
const iconAliases: Record<string, string> = {
  calendar: 'asistencia',
  fire: 'racha',
  lightning: 'comenzar',
  streak: 'racha',
  trophy: 'rankings',
  workout: 'comenzar-entrenamiento',
  exercise: 'comenzar-entrenamiento',
  history: 'en-curso',
  user: 'perfil',
  users: 'socios',
  lock: 'darse-de-baja',
  logout: 'darse-de-baja',
  trash: 'basura',
  delete: 'basura',
  edit: 'editar',
  save: 'sesion-guardada',
  check: 'éxito',
  success: 'éxito',
  alert: 'alerta',
  warning: 'alerta',
  error: 'error',
  routine: 'mis-rutinas',
  routines: 'mis-rutinas',
  measures: 'medidas',
  payments: 'pagos',
  card: 'pagos',
  records: 'mis-records',
  settings: 'configurar',
  gear: 'configurar',
  info: 'consejo',
  idea: 'consejo',
  lightbulb: 'consejo',
  chart: 'progreso',
  list: 'mis-rutinas',
  pause: 'descanso',
  rest: 'descanso',
};

// Formas SVG adicionales para controles interactivos específicos
const customShapes: Record<string, IconData> = {
  plus: {
    viewBox: '0 0 24 24',
    inner: '<path fill="currentColor" d="M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2z"/>',
  },
  close: {
    viewBox: '0 0 24 24',
    inner: '<path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>',
  },
  x: {
    viewBox: '0 0 24 24',
    inner: '<path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>',
  },
  search: {
    viewBox: '0 0 24 24',
    inner: '<path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>',
  },
  skip: {
    viewBox: '0 0 24 24',
    inner: '<polygon fill="currentColor" points="5,4 15,12 5,20"/><rect fill="currentColor" x="16" y="4" width="3" height="16"/>',
  },
};

/**
 * Retorna la cadena SVG limpia para cualquier icono del sistema Tyris.
 * Usa `currentColor` por defecto para máxima flexibilidad con CSS.
 */
export function getTyrisIcon(
  name: TyrisIconName,
  options: {
    size?: number;
    className?: string;
    style?: string;
  } = {}
): string {
  const size = options.size || 20;
  const className = options.className || 'tyris-icon';
  const customStyle = options.style ? `style="${options.style}"` : '';

  const cleanName = name
    .toLowerCase()
    .trim()
    .replace(/^icon-/, '')
    .replace(/_1$/, '');

  const resolvedName = iconAliases[cleanName] || cleanName;
  const icon = customShapes[resolvedName] || iconsMap[resolvedName] || iconsMap['panel-principal'];

  return `<svg class="${className}" width="${size}" height="${size}" viewBox="${icon.viewBox}" fill="none" xmlns="http://www.w3.org/2000/svg" ${customStyle}>${icon.inner}</svg>`;
}
